import { routes } from "@/routes/utils";
import { CreditCard, Gauge, Handshake, ReceiptText } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const useReportSection = () => {
  const navigate = useNavigate();
  const [reportCards] = useState<any>([
    {
      title: (
        <span>
          Invoice
          360 Report
        </span>
      ),
      label: "Invoice 360 Report",
      description: "Comprehensive invoice details and analytics.",
      link: routes.reports,
      icon: ReceiptText,
      className: "bg-blue-50 border-blue-100",
      iconClassName: "bg-blue-100 text-blue-600",
      textClassName: "text-primary",
      section: "invoice"
    },
    {
      title: (
        <span>
          Payment
          360 Report
        </span>
      ),
      label: "Payment 360 Report",
      description: "Track payments and reconciliation insights.",
      link: routes.paymentReport,
      icon: Handshake,
      className: "bg-green-50 border-green-100",
      iconClassName: "bg-green-100 text-green-600",
      textClassName: "text-green-700",
      section: "invoice"
    },
    {
      title: (
        <span>
          Tolerance
          Report
        </span>
      ),
      label: "Tolerance Report",
      description: "Analyze tolerance limits and exceptions.",
      link: routes.tolerance,
      icon: Gauge,
      className: "bg-violet-50 border-violet-100",
      iconClassName: "bg-violet-100 text-violet-600",
      textClassName: "text-violet-700",
      section: "invoice"
    },
    {
      title: (
        <span>
          Collection 360
          Report
        </span>
      ),
      label: "Collection 360 Report",
      description: "Track collections and outstanding analysis.",
      link: routes.ar360,
      icon: CreditCard,
      className: "bg-amber-50 border-amber-100",
      iconClassName: "bg-amber-100 text-amber-600",
      textClassName: "text-amber-600",
      section: "collection"
    },
  ]);

  const onReportCardClick = (link: any) => () => {
    link ? navigate(link) : "";
  };

  return {
    onReportCardClick,
    reportCards,
  };
};

export default useReportSection;
